import React from 'react';
import cn from 'classnames';

import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';

import CN from './IconStatus.module.scss';

const IconStatus = ({ children, width, position, tag, variant, space }) => (
  <div
    data-bem="IconStatus"
    data-tag={fromAnyToTrimmed(tag)}
    className={cn({
      [CN.component]: true,
      [CN[`${position}Position`]]: position,
      [CN[`${space}Space`]]: space,
    })}
  >
    <div
      className={cn({
        [CN.circle]: true,
        [CN[`${variant}Variant`]]: variant,
        [CN[`${width}Width`]]: width,
      })}
    >
      {children}
    </div>
  </div>
);

export default IconStatus;
